import Table from "react-bootstrap/Table";
import cn from "classnames";

import "./style.scss";
import { DataGridConfig } from "./types";
import { useFilter } from "./useFilter";
import useMediaQuery from "components/utils/useMediaQuery";

export const DataGrid: React.FC<{
    className?: string;
    children: React.ReactNode;
    withWrapper?: boolean;
}> = ({ className, children, withWrapper = true }) => {
    const table = (
        <Table className={cn("data-grid position-relative", className)} bordered responsive>
            {children}
        </Table>
    );

    if (!withWrapper) {
        return table;
    }

    return <div className="data-grid-wrapper">{table}</div>;
};

export const DataGridWithFilter: React.FC<{
    className?: string;
    withWrapper?: boolean;
    gridConfig: DataGridConfig;
    filter?: string;
    onFilterChange?: (filter: string) => void;
    onSortChange?: (key: string, forceAsc?: boolean) => void;
    children: (props: ReturnType<typeof useFilter>) => React.ReactNode;
}> = ({ className, children, withWrapper = true, onFilterChange, onSortChange, gridConfig, filter }) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const filterControllers = useFilter({
        filterString: filter ?? gridConfig?.filter,
        onFilterChange,
        onSortChange,
        notClearableFilterKeys: gridConfig?.notClearableFilterKeys,
    });

    const table = (
        <Table
            bsPrefix={cn({ "rounded-3": !isMobile }, "border table")}
            className={cn("data-grid data-grid-with-filter position-relative border-0 shadow-none", className)}
            bordered
            responsive
        >
            {children(filterControllers)}
        </Table>
    );

    if (!withWrapper) {
        return table;
    }

    return <div className="data-grid-wrapper data-grid-with-filter-wrapper">{table}</div>;
};
